import React from 'react';
import { Typography } from 'antd';
import DashboardCard from './DashboardCard';

const { Text } = Typography;

export default function MetricCard({
  label,
  value,
  hint,
  icon,
  suffix,
  valueColor,
  comparison,
  onClick,
}) {
  const clickable = typeof onClick === 'function';

  return (
    <DashboardCard
      style={{
        height: '100%',
        cursor: clickable ? 'pointer' : 'default',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
      }}
    >
      <div
        onClick={onClick}
        onKeyDown={(event) => {
          if (
            clickable
            && (event.key === 'Enter' || event.key === ' ')
          ) {
            event.preventDefault();
            onClick();
          }
        }}
        role={clickable ? 'button' : undefined}
        tabIndex={clickable ? 0 : undefined}
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 16,
          outline: 'none',
        }}
      >
        <div style={{ minWidth: 0 }}>
          <Text
            type="secondary"
            style={{
              display: 'block',
              marginBottom: 8,
              fontSize: 13,
            }}
          >
            {label}
          </Text>

          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
              gap: 6,
            }}
          >
            <span
              style={{
                fontSize: 30,
                fontWeight: 650,
                lineHeight: 1.1,
                color: valueColor,
              }}
            >
              {value}
            </span>

            {suffix && (
              <Text type="secondary">
                {suffix}
              </Text>
            )}
          </div>

          {hint && (
            <Text
              type="secondary"
              style={{
                display: 'block',
                marginTop: 8,
                fontSize: 12,
              }}
            >
              {hint}
            </Text>
          )}

          {comparison && (
            <Text
              style={{
                display: 'block',
                marginTop: 5,
                fontSize: 12,
                color: '#595959',
              }}
            >
              {comparison}
            </Text>
          )}
        </div>

        {icon && (
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(114, 46, 209, 0.08)',
              color: '#722ed1',
              fontSize: 19,
              flexShrink: 0,
            }}
          >
            {icon}
          </div>
        )}
      </div>
    </DashboardCard>
  );
}
